import React from 'react';
import { Box, Typography } from '@mui/material';
import { AudiencePill, CardActions, FONT, PositionBadge, StatusPill, cardSx } from './contentShared';

const SubcategoryCard = ({ subcategory, onEdit, onDelete }) => (
  <Box sx={cardSx}>
    <Box onClick={() => onEdit && onEdit(subcategory)} sx={{ cursor: 'pointer', position: 'relative', width: '100%', paddingBottom: '75%', background: '#f1f5f9' }}>
      <img
        src={subcategory.image || subcategory.linkId?.image || '/img/placeholder.png'}
        alt={subcategory.linkId?.title || 'Home category'}
        style={{ position: 'absolute', width: '100%', height: '100%', objectFit: 'cover' }}
      />
      <Box sx={{ position: 'absolute', top: 10, left: 10 }}><PositionBadge position={subcategory.position} /></Box>
      <Box sx={{ position: 'absolute', top: 10, right: 10 }}><StatusPill status={subcategory.status || subcategory.linkId?.status} /></Box>
    </Box>
    <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1, flex: 1 }}>
      <Typography sx={{ fontFamily: FONT, fontSize: 14.5, fontWeight: 800, color: '#0f172a', lineHeight: 1.3 }}>
        {subcategory.linkId?.title || 'Untitled'}
      </Typography>
      <Box sx={{ display: 'flex', gap: 0.75, alignItems: 'center' }}>
        <AudiencePill value={subcategory.showTo} />
        {subcategory.type && <Typography sx={{ fontFamily: FONT, fontSize: 11.5, color: '#64748b' }}>{subcategory.type}</Typography>}
      </Box>
      <Box sx={{ mt: 'auto', pt: 1, display: 'flex', justifyContent: 'flex-end' }}>
        <CardActions onEdit={() => onEdit && onEdit(subcategory)} onDelete={() => onDelete && onDelete(subcategory)} />
      </Box>
    </Box>
  </Box>
);

export default SubcategoryCard;
